<script lang="ts">
  let { rank }: { rank: number } = $props();
  const cls = $derived(rank === 1 ? 'rank-gold' : rank === 2 ? 'rank-silver' : rank === 3 ? 'rank-bronze' : '');
</script>

<span class="rank-num {cls}">{rank}</span>

<style>
  .rank-num {
    font-size: 1.875rem;
    font-weight: 800;
    line-height: 1;
    color: var(--cyan);
  }
</style>
